module.exports = __webpack_public_path__ + "img/stormCloud.c3cef25a.svg";